import React, { useEffect, useState } from 'react'
import {
    Box,
    Chip,
    Grid,
    IconButton,
    Tooltip,
    Typography
} from "@mui/material";
import TableContainer from '../../../Components/TableContainer/TableContainer';
import { useDispatch } from 'react-redux';
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import Constant from '../../../Utils/Constant';
import { useNavigate } from 'react-router-dom';
import { GET_INCOMPLETE_JOB } from '../../../Redux/Slices/IncompleteServiceSlice/IncompleteServiceSlice.action';
const IncompleteServices = () => {
    const pageSize = 15;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [page, setPage] = useState(0);
    const [count, setCount] = useState(0);
    const [incompleteJobList, setIncompleteJobList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const columns = [
        {
            field: "rowid",
            headerName: "Sr.No.",
            minWidth: 100,
            filterable: false,
            editable: false,
            sortable: false,
            disableColumnMenu: true,
        },
        {
            field: "full_name",
            headerName: "User Name",
            minWidth: 250,
            filterable: true,
            sortable: true,
            renderCell: (params) => {
                const fullName = params?.row?.user_details?.full_name || "--";
                return (
                    <Tooltip title={fullName?.length > 25 ? fullName : ""}>
                        <span>
                            {fullName?.length > 25
                                ? `${fullName?.substring(0, 25)}...`
                                : fullName}
                        </span>
                    </Tooltip>
                );
            },
        },
        {
            field: "interpreter_name",
            headerName: "Interpreter Name",
            flex: 1,
            minWidth: 300,
            hideOnMobile: true,
            renderCell: (params) => (
                <Tooltip title={params?.row?.interpreter_details?.full_name || "--"}>
                    <span>{params?.row?.interpreter_details?.full_name || "--"}</span>
                </Tooltip>
            ),
        },
        // {
        //     field: "email",
        //     headerName: "Email",
        //     flex: 1,
        //     minWidth: 300,
        //     hideOnMobile: true,
        //     renderCell: (params) => (
        //         <Tooltip title={params?.row?.email || "--"}>
        //             <span>{params?.row?.email || "--"}</span>
        //         </Tooltip>
        //     ),
        // },

        // {
        //     field: "phone",
        //     headerName: "Phone Number",
        //     minWidth: 200,
        //     filterable: false,
        //     editable: false,
        //     sortable: false,
        //     hideOnMobile: true,
        //     disableColumnMenu: true,
        //     renderCell: (params) => (
        //         <span>
        //             {params?.row?.phno_cc && params?.row?.phno
        //                 ? `${params?.row?.phno_cc} ${params?.row?.phno}`
        //                 : "--"}
        //         </span>
        //     ),
        // },
        {
            field: "status",
            headerName: "Status",
            minWidth: 150,
            filterable: false,
            editable: false,
            sortable: false,
            hideOnMobile: true,
            disableColumnMenu: true,
            renderCell: (params) => {
                const { transfer_intent, refund_intent } = params?.row || {};
                const isSolved = !!(transfer_intent || refund_intent);

                return (
                    <Chip
                        label={isSolved ? "Solved" : "Pending"}
                        size="small"
                        variant="outlined"
                        sx={{
                            border: isSolved ? "1px solid #16BC00CC" : "1px solid #FFCE80",
                            height: "36px",
                            borderRadius: "10px",
                            width: "117px",
                            fontFamily: "Outfit",
                            background: isSolved ? "#16BC00CC" : "#FFCE80",
                            color: isSolved ? "#fff" : "#000", // Optional: adjust text color for contrast
                        }}
                    />
                );
            },
        },
        {
            field: "action",
            headerName: "Actions",
            minWidth: 140,
            filterable: false,
            editable: false,
            sortable: false,
            renderCell: (params) => {
                const actionButtons = [];

                return (
                    <Tooltip title="View" key="view">
                        <IconButton
                            onClick={() => {
                                navigate("/admin/incomplete-services-details", {
                                    state: {
                                        inCompleteJobId: params?.row?.id,
                                        is_refund: params?.row?.is_refund,
                                        is_transfer: params?.row?.is_transfer
                                    },
                                });
                            }}
                            sx={{
                                width: "30px",
                                height: "30px",
                                borderRadius: "4px",
                                background: "#0097B2",
                                "&:hover": {
                                    background: "#0097B2",
                                },
                            }}
                        >
                            <RemoveRedEyeIcon sx={{ color: "#fff" }} />
                        </IconButton>
                    </Tooltip>
                );
            },
        },
    ];
    useEffect(() => {
        getIncompleteJobList();
    }, [page, dispatch]);
    const getIncompleteJobList = async () => {
        setIsLoading(true)
        await dispatch(GET_INCOMPLETE_JOB({ page, pageSize })).unwrap()
            .then((res) => {
                if (res && res?.s === 1) {
                    const Rowdata = res?.r?.map((data, i) => ({
                        rowid: i + 1 + page * pageSize,
                        ...data,
                    }));
                    setIsLoading(false)
                    setIncompleteJobList(Rowdata);
                    page === 0 && setCount(res?.total || 0);
                } else {
                    setIncompleteJobList([]);
                    setIsLoading(false)
                }
            }).catch((error) => {
                console.log('error', error);
                setIsLoading(false)
            })
    }
    const handlePageChange = (newPage) => {
        setPage(newPage);
    };
    // const handlePageSizeChange = (newPageSize) => {
    //     setLimit(newPageSize);
    //     setSkip(0);
    // };
    return (
        <>
            <Box
                sx={{
                    width: "100%",
                    bgcolor: "#fff",
                    padding: '10px'
                }}
            >
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <Typography sx={{ fontSize: "24px", fontWeight: "500", fontFamily: 'Outfit', }}>
                            Incomplete Services
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={3}>

                    </Grid>
                </Grid>
                <Box
                    sx={{
                        width: "100%",
                        paddingTop: "24px",
                    }}
                >
                    <TableContainer
                        rows={incompleteJobList}
                        columns={columns}
                        loading={isLoading}
                        pageSize={pageSize}
                        page={page}
                        totalCount={count}
                        handlePageChange={handlePageChange}
                        paginationShow={true}
                        sx={{
                            height: "calc(100vh - 130px)"
                        }}
                    />
                </Box>
            </Box>
        </>
    )
}

export default IncompleteServices